(function () {
  if (window.customElements.get('up2-loox-reviews')) return;

  var API_ROOT = 'https://storefront-api.loox.io';
  var STAR_PATH =
    'M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z';

  function pick(object, keys, fallback) {
    if (!object || typeof object !== 'object') return fallback;
    for (var i = 0; i < keys.length; i++) {
      var value = object[keys[i]];
      if (value !== undefined && value !== null && value !== '') return value;
    }
    return fallback;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function absoluteUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function starsMarkup(rating, label) {
    var count = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    var html = '<span class="up2-loox-card__stars" role="img" aria-label="' + escapeHtml(label) + '">';
    for (var i = 1; i <= 5; i++) {
      html +=
        '<svg class="up2-loox-card__star' +
        (i > count ? ' is-empty' : '') +
        '" viewBox="0 0 15 15" width="15" height="15" aria-hidden="true" focusable="false"><path d="' +
        STAR_PATH +
        '" fill="currentColor"></path></svg>';
    }
    return html + '</span>';
  }

  function fullImageUrl(url) {
    if (!url) return '';
    return url.replace(/_mid(\.[a-zA-Z0-9]+)/, '$1');
  }

  function isVideoMedia(item) {
    if (!item || typeof item === 'string') return false;
    var type = String(item.t || item.type || '').toLowerCase();
    return type === 'video' || Boolean(item.video || item.mp4);
  }

  function firstMedia(review) {
    var media = review.media || review.images || review.photos || [];
    if (!Array.isArray(media)) return { url: '', full: '', alt: '', type: 'photo' };
    for (var i = 0; i < media.length; i++) {
      var item = media[i];
      if (!item) continue;
      if (typeof item === 'string') {
        var photoUrl = absoluteUrl(item);
        return { url: photoUrl, full: fullImageUrl(photoUrl), alt: '', type: 'photo' };
      }
      var url = absoluteUrl(item.url || item.src || item.imageUrl || '');
      if (!url) continue;
      return {
        url: url,
        full: fullImageUrl(url),
        alt: item.alt || '',
        type: isVideoMedia(item) ? 'video' : 'photo',
      };
    }
    return { url: '', full: '', alt: '', type: 'photo' };
  }

  function formatDate(value, locale) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    try {
      return new Intl.DateTimeFormat(locale || 'de', { day: 'numeric', month: 'short', year: 'numeric' }).format(date);
    } catch (error) {
      return '';
    }
  }

  function reviewProduct(review) {
    return review && typeof review.product === 'object' ? review.product : {};
  }

  function reviewHandle(review) {
    return String(reviewProduct(review).handle || '').toLowerCase();
  }

  function reviewProductId(review) {
    return String(reviewProduct(review).id || pick(review, ['productId', 'product_id'], '')).replace(/\D/g, '');
  }

  function filterReviews(reviews, ids, handles) {
    if (!Array.isArray(reviews)) return [];
    if (!ids.length && !handles.length) return reviews.slice();
    return reviews.filter(function (review) {
      var id = reviewProductId(review);
      var handle = reviewHandle(review);
      if (id && ids.indexOf(id) !== -1) return true;
      if (handle && handles.indexOf(handle) !== -1) return true;
      return false;
    });
  }

  function mixReviews(reviews) {
    var buckets = {};
    var order = [];
    reviews.forEach(function (review) {
      var key = mixKey(review);
      if (!buckets[key]) {
        buckets[key] = [];
        order.push(key);
      }
      buckets[key].push(review);
    });
    var mixed = [];
    var added = true;
    while (added) {
      added = false;
      order.forEach(function (key) {
        if (buckets[key].length) {
          mixed.push(buckets[key].shift());
          added = true;
        }
      });
    }
    return mixed;
  }

  var HANDLE_ALIASES = {
    'nfc-qr-aufsteller-fuer-google-bewertung': ['google-review-boost-tischaufsteller'],
  };

  function expandHandles(handles) {
    var extra = [];
    handles.forEach(function (handle) {
      (HANDLE_ALIASES[handle] || []).forEach(function (alias) {
        if (handles.indexOf(alias) === -1 && extra.indexOf(alias) === -1) extra.push(alias);
      });
    });
    return handles.concat(extra);
  }

  function mixKey(review) {
    var handle = reviewHandle(review);
    if (handle === 'google-review-boost-tischaufsteller') return 'nfc-qr-aufsteller-fuer-google-bewertung';
    return handle || reviewProductId(review) || '_';
  }

  function ratingLabel(rating, template) {
    return String(template || '{{ rating_value }} / {{ rating_max }}')
      .replace('{{ rating_value }}', String(rating))
      .replace('{{ rating_max }}', '5');
  }

  var Up2LooxReviews = class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.grid = this.querySelector('[data-loox-grid]');
      this.strip = this.querySelector('[data-loox-scroller]') || this.grid;
      this.more = this.querySelector('[data-loox-more]');
      this.status = this.querySelector('[data-loox-status]');
      this.dots = this.querySelector('[data-loox-dots]');
      this.config = this._readConfig();
      if (!this.grid) return;
      if (this.more) this.more.addEventListener('click', this._onMore.bind(this));
      this.strip.addEventListener('scroll', this._onScroll.bind(this), { passive: true });
      this.grid.addEventListener('click', this._onMediaClick.bind(this));
      this._bindDrag();
      this._pool = mixReviews(
        filterReviews(this.config.reviews, this.config.productIds, expandHandles(this.config.productHandles)),
      );
      if (this.config.storeId) {
        this._nextUrl = this._reviewsUrl();
        this._load(true);
        return;
      }
      this._offset = 0;
      this._renderFeed();
    }

    _readConfig() {
      var script = this.querySelector('[data-loox-config]');
      var parsed = {};
      if (script) {
        try {
          parsed = JSON.parse(script.textContent || '{}');
        } catch (error) {
          parsed = {};
        }
      }
      return {
        storeId: String(parsed.storeId || this.getAttribute('data-store-id') || '').trim(),
        locale: parsed.locale || document.documentElement.lang || 'de',
        limit: Number(parsed.limit) || 6,
        verified: parsed.verified || '',
        ratingInfo: parsed.ratingInfo || '',
        goToItem: parsed.goToItem || '',
        enlarge: parsed.enlarge || '',
        playVideo: parsed.playVideo || '',
        close: parsed.close || '',
        reviews: Array.isArray(parsed.reviews) ? parsed.reviews : [],
        productIds: Array.isArray(parsed.productIds)
          ? parsed.productIds
              .map(function (id) {
                return String(id).replace(/\D/g, '');
              })
              .filter(Boolean)
          : [],
        productHandles: Array.isArray(parsed.productHandles)
          ? parsed.productHandles
              .map(function (handle) {
                return String(handle).toLowerCase();
              })
              .filter(Boolean)
          : [],
      };
    }

    _reviewsUrl(page) {
      var params = new URLSearchParams({
        limit: String(this.config.limit),
        page: String(page || 1),
        sort: 'featured',
        locale: this.config.locale,
      });
      if (this.config.productIds.length) params.set('productIds', this.config.productIds.join(','));
      return (
        API_ROOT +
        '/storefront/v1/store/' +
        encodeURIComponent(this.config.storeId) +
        '/product-reviews?' +
        params.toString()
      );
    }

    _onMore(event) {
      event.preventDefault();
      if (this._loading) return;
      if (this._nextUrl) {
        this._load(false);
        return;
      }
      this._renderFeed();
    }

    _setBusy(busy) {
      this._loading = busy;
      if (this.more) this.more.disabled = busy;
      if (this.status) this.status.hidden = !busy;
    }

    _renderFeed() {
      var slice = this._pool.slice(this._offset, this._offset + this.config.limit);
      slice.forEach(
        function (review) {
          var node = this._card(review);
          if (node) this.grid.appendChild(node);
        }.bind(this),
      );
      this._offset += slice.length;
      if (this.more) this.more.hidden = this._offset >= this._pool.length;
      this._syncDots();
    }

    _load(reset) {
      var url = this._nextUrl;
      if (!url) return;
      this._setBusy(true);
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('loox-http-' + response.status);
          return response.json();
        })
        .then(this._onData.bind(this, reset))
        .catch(this._onError.bind(this, reset))
        .then(this._setBusy.bind(this, false));
    }

    _onData(reset, data) {
      var reviews = mixReviews(
        filterReviews(
          (data && (data.reviews || data.items || data.data)) || [],
          this.config.productIds,
          expandHandles(this.config.productHandles),
        ),
      );
      var pagination = (data && data.pagination) || {};
      if (reset) this.grid.replaceChildren();
      reviews.forEach(
        function (review) {
          var node = this._card(review);
          if (node) this.grid.appendChild(node);
        }.bind(this),
      );
      this._nextUrl = this._nextPage(pagination);
      if (this.more) this.more.hidden = !this._nextUrl;
      this._syncDots();
    }

    _nextPage(pagination) {
      if (!pagination || pagination.hasMore === false) return '';
      var next = pagination.nextPageUrl || pagination.next_page_url || '';
      if (!next) return '';
      if (/^https?:\/\//.test(next)) return next;
      return API_ROOT + next;
    }

    _onError(reset) {
      this._nextUrl = '';
      if (reset && this._pool.length) {
        this._offset = 0;
        this._renderFeed();
        return;
      }
      if (this.more) this.more.hidden = true;
    }

    _syncDots() {
      if (!this.dots || !this.grid) return;
      var cards = this.grid.querySelectorAll('.up2-loox-card');
      this.dots.replaceChildren();
      if (cards.length < 2) {
        this.dots.hidden = true;
        return;
      }
      this.dots.hidden = false;
      var template = this.config.goToItem || '';
      cards.forEach(
        function (card, index) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'tap-area';
          button.setAttribute('aria-current', index === 0 ? 'true' : 'false');
          var label = document.createElement('span');
          label.className = 'sr-only';
          label.textContent = template.replace('#', String(index + 1)).replace('{{ index }}', String(index + 1));
          button.appendChild(label);
          button.addEventListener('click', function () {
            card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
          });
          this.dots.appendChild(button);
        }.bind(this),
      );
      this._updateDots();
    }

    _isMobileStrip() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    _bindDrag() {
      this._onPointerDown = this._onPointerDown.bind(this);
      this._onPointerMove = this._onPointerMove.bind(this);
      this._onPointerUp = this._onPointerUp.bind(this);
      this._onClickCapture = this._onClickCapture.bind(this);
      this.strip.addEventListener('pointerdown', this._onPointerDown);
      this.strip.addEventListener('pointermove', this._onPointerMove);
      this.strip.addEventListener('pointerup', this._onPointerUp);
      this.strip.addEventListener('pointercancel', this._onPointerUp);
      this.strip.addEventListener('lostpointercapture', this._onPointerUp);
      this.strip.addEventListener('click', this._onClickCapture, true);
      this.strip.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });
    }

    _onPointerDown(event) {
      if (!this._isMobileStrip()) return;
      if (event.pointerType === 'touch') return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      this._drag = {
        id: event.pointerId,
        startX: event.clientX,
        startScroll: this.strip.scrollLeft,
        moved: false,
      };
      this._suppressClick = false;
      try {
        this.strip.setPointerCapture(event.pointerId);
      } catch (error) {
        // Synthetic or already-released pointers can throw.
      }
    }

    _onPointerMove(event) {
      if (!this._drag || event.pointerId !== this._drag.id) return;
      var dx = event.clientX - this._drag.startX;
      if (!this._drag.moved && Math.abs(dx) < 6) return;
      if (!this._drag.moved) {
        this._drag.moved = true;
        this.strip.classList.add('is-dragging');
      }
      event.preventDefault();
      this.strip.scrollLeft = this._drag.startScroll - dx;
    }

    _onPointerUp(event) {
      if (!this._drag) return;
      if (event.pointerId && event.pointerId !== this._drag.id) return;
      if (this._drag.moved) this._suppressClick = true;
      this._drag = null;
      this.strip.classList.remove('is-dragging');
    }

    _onClickCapture(event) {
      if (!this._suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      this._suppressClick = false;
    }

    _onScroll() {
      if (this._dotFrame) return;
      this._dotFrame = requestAnimationFrame(
        function () {
          this._dotFrame = 0;
          this._updateDots();
        }.bind(this),
      );
    }

    _updateDots() {
      if (!this.dots || !this.grid) return;
      var buttons = this.dots.querySelectorAll('button');
      var cards = this.grid.querySelectorAll('.up2-loox-card');
      if (!buttons.length || !cards.length) return;
      var origin =
        this.strip.getBoundingClientRect().left +
        (parseFloat(getComputedStyle(this.strip).scrollPaddingInlineStart) ||
          parseFloat(getComputedStyle(this.grid).paddingInlineStart) ||
          0);
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, index) {
        var dist = Math.abs(card.getBoundingClientRect().left - origin);
        if (dist < bestDist) {
          bestDist = dist;
          best = index;
        }
      });
      buttons.forEach(function (button, index) {
        button.setAttribute('aria-current', index === best ? 'true' : 'false');
      });
    }

    _onMediaClick(event) {
      var trigger = event.target.closest('[data-loox-media]');
      if (!trigger || !this.grid.contains(trigger)) return;
      event.preventDefault();
      this._openMedia(trigger);
    }

    _ensureLightbox() {
      if (this._lightbox) return this._lightbox;
      var dialog = document.createElement('dialog');
      dialog.className = 'up2-loox-lightbox';
      dialog.setAttribute('aria-modal', 'true');
      dialog.innerHTML =
        '<button type="button" class="up2-loox-lightbox__close tap-area" data-loox-lightbox-close>' +
        '<span class="sr-only">' +
        escapeHtml(this.config.close) +
        '</span>' +
        '<svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4.3 4.3a1 1 0 0 1 1.4 0L10 8.6l4.3-4.3a1 1 0 1 1 1.4 1.4L11.4 10l4.3 4.3a1 1 0 1 1-1.4 1.4L10 11.4l-4.3 4.3a1 1 0 1 1-1.4-1.4L8.6 10 4.3 5.7a1 1 0 0 1 0-1.4z"></path></svg>' +
        '</button>' +
        '<div class="up2-loox-lightbox__stage" data-loox-lightbox-stage></div>';
      this.appendChild(dialog);
      dialog.querySelector('[data-loox-lightbox-close]').addEventListener('click', this._closeLightbox.bind(this));
      dialog.addEventListener(
        'click',
        function (event) {
          if (event.target === dialog) this._closeLightbox();
        }.bind(this),
      );
      dialog.addEventListener('close', this._clearLightbox.bind(this));
      this._lightbox = dialog;
      return dialog;
    }

    _clearLightbox() {
      if (!this._lightbox) return;
      var stage = this._lightbox.querySelector('[data-loox-lightbox-stage]');
      if (stage) stage.replaceChildren();
    }

    _closeLightbox() {
      if (!this._lightbox || !this._lightbox.open) return;
      if (typeof this._lightbox.close === 'function') this._lightbox.close();
    }

    _openMedia(trigger) {
      var type = trigger.getAttribute('data-loox-type') || 'photo';
      var reviewId = trigger.getAttribute('data-loox-id') || '';
      var src = trigger.getAttribute('data-loox-full') || trigger.getAttribute('data-loox-src') || '';
      var alt = trigger.getAttribute('data-loox-alt') || '';
      if (type === 'video' && reviewId && window.LOOX && typeof window.LOOX.openQV === 'function') {
        try {
          window.LOOX.openQV(reviewId, 'reviews');
          return;
        } catch (error) {
          // Fall through to the in-theme player if Loox quick view is unavailable.
        }
      }
      var dialog = this._ensureLightbox();
      var stage = dialog.querySelector('[data-loox-lightbox-stage]');
      stage.replaceChildren();
      dialog.classList.toggle('is-video', type === 'video');
      if (type === 'video' && reviewId) {
        var frame = document.createElement('iframe');
        frame.className = 'up2-loox-lightbox__frame';
        frame.src = 'https://loox.io/post/quickview/' + encodeURIComponent(reviewId) + '?ref=reviews';
        frame.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
        frame.setAttribute('allowfullscreen', '');
        frame.title = this.config.playVideo || 'Video';
        stage.appendChild(frame);
      } else if (src) {
        var image = document.createElement('img');
        image.className = 'up2-loox-lightbox__image';
        image.src = src;
        image.alt = alt;
        stage.appendChild(image);
      } else {
        return;
      }
      if (typeof dialog.showModal === 'function') dialog.showModal();
    }

    _card(review) {
      if (!review) return null;
      var rating = Number(pick(review, ['rating', 'stars', 'score'], 0));
      var body = pick(review, ['body', 'review', 'content', 'text', 'title'], '');
      var reviewer = typeof review.reviewer === 'object' ? review.reviewer : {};
      var name = pick(
        reviewer,
        ['name', 'displayName'],
        typeof review.author === 'string' ? review.author : pick(review, ['author', 'name'], ''),
      );
      var verified = Boolean(review.verified || reviewer.verified);
      var product = review.product || {};
      var productName = pick(product, ['name', 'title'], '');
      var productUrl = product.handle ? '/products/' + product.handle : pick(product, ['url'], '');
      var media = firstMedia(review);
      var date = formatDate(pick(review, ['date', 'createdAt', 'created_at'], ''), this.config.locale);
      var article = document.createElement('article');
      article.className = 'up2-loox-card snap-start';
      var html = '';
      if (media.url) {
        var isVideo = media.type === 'video';
        var label = isVideo ? this.config.playVideo : this.config.enlarge;
        html +=
          '<button type="button" class="up2-loox-card__media' +
          (isVideo ? ' up2-loox-card__media--video' : '') +
          '" data-loox-media data-loox-type="' +
          (isVideo ? 'video' : 'photo') +
          '" data-loox-id="' +
          escapeHtml(review.id || '') +
          '" data-loox-src="' +
          escapeHtml(media.url) +
          '" data-loox-full="' +
          escapeHtml(media.full || media.url) +
          '" data-loox-alt="' +
          escapeHtml(media.alt) +
          '" aria-label="' +
          escapeHtml(label) +
          '">';
        html +=
          '<img src="' +
          escapeHtml(media.url) +
          '" alt="' +
          escapeHtml(media.alt) +
          '" loading="lazy" decoding="async">';
        if (isVideo) {
          html +=
            '<span class="up2-loox-card__play" aria-hidden="true"><svg viewBox="0 0 24 24" width="28" height="28"><path fill="currentColor" d="M8 5.2v13.6L19 12 8 5.2z"></path></svg></span>';
        }
        html += '</button>';
      }
      html += '<div class="up2-loox-card__body">';
      html += starsMarkup(rating, ratingLabel(rating, this.config.ratingInfo));
      if (name || verified) {
        html += '<p class="up2-loox-card__author">';
        if (name) html += '<span>' + escapeHtml(name) + '</span>';
        if (verified && this.config.verified) {
          html += '<span class="up2-loox-card__verified">' + escapeHtml(this.config.verified) + '</span>';
        }
        html += '</p>';
      }
      if (date) html += '<p class="up2-loox-card__date">' + escapeHtml(date) + '</p>';
      if (body) html += '<p class="up2-loox-card__text">' + escapeHtml(body) + '</p>';
      if (productName) {
        if (productUrl) {
          html +=
            '<a class="up2-loox-card__product" href="' +
            escapeHtml(productUrl) +
            '" draggable="false">' +
            escapeHtml(productName) +
            '</a>';
        } else {
          html += '<p class="up2-loox-card__product">' + escapeHtml(productName) + '</p>';
        }
      }
      html += '</div>';
      article.innerHTML = html;
      return article;
    }
  };

  window.customElements.define('up2-loox-reviews', Up2LooxReviews);
})();
